import React, { useEffect, useState } from "react";
import { Col, Container, Row, Spinner } from "reactstrap";

// redux
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { fetchOrders } from "../../slices/apps/orderSlice";
import { fetchCustomers } from "../../slices/apps/customerSlice";

// sayfalar, modallar vs.
import OrderTable from "./OrderTable";

const Orders = () => {
  document.title = "Servisler | Metiner Avantaj+";

  const dispatch = useDispatch();

  // states
  const [loading, setLoading] = useState(true);

  const { ordersRefresh } = useSelector((state) => {
    return {
      ordersRefresh: state.order.ordersRefresh,
    };
  }, shallowEqual);

  const fetchData = async () => {
    setLoading(true);

    try {
      await dispatch(fetchOrders());
      await dispatch(fetchCustomers());
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [dispatch, ordersRefresh]);

  if (loading) {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ minHeight: "50vh" }}
            >
              <Spinner color="primary">Yükleniyor...</Spinner>
            </div>
          </Container>
        </div>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xs={12}>
              <OrderTable />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Orders;
